var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker-info-window"},[_c('marker-info-window-details',{attrs:{"data-cy":"marker-details","deviceTitle":_vm.itemInfo.title,"objectId":_vm.itemInfo.objectId,"objectTypeId":_vm.itemInfo.objectTypeId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }